module.exports = __webpack_public_path__ + "img/certif-empty.3933b71e.svg";